import React, { useEffect, useState } from "react";

const links = [
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Pricing", href: "#pricing" },
  { label: "About", href: "#about" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-md bg-[#F9F8F6]/80 border-b border-[#D6CDBB]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
        >
          <span className="font-serif-display text-base md:text-xl tracking-tight text-[#2B211A] leading-tight">
            Dira Yanuar Rusdias <span className="text-[#8C735D]">LLC</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-body text-[#2B211A] hover:text-[#8C735D] transition-colors duration-300 tracking-wide"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="nav-cta-contact"
            className="hidden md:inline-flex items-center gap-2 bg-[#2B211A] hover:bg-[#8C735D] text-[#F9F8F6] px-5 py-2.5 rounded-full text-sm font-medium font-body transition-colors duration-300"
          >
            Schedule Consultation
            <span aria-hidden>→</span>
          </a>

          <button
            type="button"
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-full border border-[#D6CDBB] text-[#2B211A]"
          >
            <span className={`block w-4 h-px bg-[#2B211A] transition-transform ${open ? "translate-y-[3px] rotate-45" : ""}`} />
            <span className={`block w-4 h-px bg-[#2B211A] -mt-1 transition-opacity ${open ? "opacity-0" : "opacity-100"}`} />
            <span className={`block w-4 h-px bg-[#2B211A] -mt-1 transition-transform ${open ? "-translate-y-[5px] -rotate-45" : ""}`} />
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden border-t border-[#D6CDBB] bg-[#F9F8F6]/95 backdrop-blur-md">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="text-base font-body text-[#2B211A]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta"
              className="inline-flex justify-center items-center bg-[#2B211A] text-[#F9F8F6] px-5 py-3 rounded-full text-sm font-medium"
            >
              Schedule Consultation
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
